<script>
import SelectField from '@phoenix/mixins/components/form/fields/SelectField';
import RadioListField from '@maison/components/form/fields/RadioListField';
import { useField } from '@phoenix/composables/field';
import FilledCheckmark from '@maison/components/form/fields/FilledCheckmark.vue';

export default {
  components: {
    FilledCheckmark,
    RadioListField,
  },

  mixins: [SelectField],

  setup(props) {
    return useField(props);
  },

  computed: {
    selectFieldClasses() {
      return ['input--select', this.fieldClasses];
    },

    fieldForRadio() {
      return {
        ...this.field,
        options: this.field.options.map((option, index) => ({
          ...option,
          id: option.id ? option.id : `${this.fieldUniqueId}_${index}`,
        })),
      };
    },
  },
};
</script>

<template>
  <template v-if="field.forceSelect || field.options.length >= 4">
    <select
      v-bind="$attrs"
      :id="fieldUniqueId"
      v-model="value"
      :name="field.name"
      :class="selectFieldClasses"
      :aria-describedby="ariaDescribedby"
      :aria-label="field.ariaLabel"
      :disabled="field.disabled"
      :prefill-enabled="true"
      autocomplete="disabled"
    >
      <option v-if="emptyChoice" value="" />
      <option v-for="(option, index) in field.options" :key="index" :value="option.value">
        {{ option.label }}
      </option>
    </select>

    <filled-checkmark v-if="isFilled" />
  </template>

  <radio-list-field v-else v-model="value" :attrs="fieldForRadio" inline :should-validate="false" />
</template>
